import { __assign } from "tslib";
import React from 'react';
import { useSwipeable } from 'react-swipeable';
import s from '../../Notifications.scss';
var VALID_SWIPE_DIRECTIONS = ['Left', 'Right'];
var NotificationSwipeableWrapper = function (_a) {
    var children = _a.children, item = _a.item, onSwiped = _a.onSwiped;
    var swipableHandlers = useSwipeable({
        onSwiped: function (ev) {
            if (VALID_SWIPE_DIRECTIONS.includes(ev.dir)) {
                onSwiped(ev.dir, item);
            }
        },
    });
    return (React.createElement("div", __assign({ className: s['swipeable-wrapper'] }, swipableHandlers), children));
};
NotificationSwipeableWrapper.displayName = 'NotificationSwipeableWrapper';
export default NotificationSwipeableWrapper;
//# sourceMappingURL=NotificationSwipeableWrapper.js.map